import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { addNetworkConnection } from 'services/BvnkNetworkService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useAddNetworkConnectionMutation = () => {
  return useMutation({
    mutationFn: addNetworkConnection,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 428) {
        logSentryError('Error: useAddNetworkConnectionMutation', error, data)
      }
    },
  })
}
